export const SET_STUDENT_ASSESSMENTS_DETAILS = 'SET_STUDENT_ASSESSMENTS_DETAILS'
export const ADD_LANGUAGE = 'ADD_LANGUAGE'
export const SET_LOCALE = 'SET_LOCALE'
export const ADD_STUDENTS_TO_LIST = 'ADD_STUDENTS_TO_LIST'
export const STUDENTS_LIST_LOADING = 'STUDENTS_LIST_LOADING'
export const CLEAR_DELETED_STUDENT_LIST = 'CLEAR_DELETED_STUDENT_LIST'
export const STUDENTS_LIST_NOT_LOADING = 'STUDENTS_LIST_NOT_LOADING'
export const LOGGED_IN = 'LOGGED_IN'
export const LOGGED_OUT = 'LOGGED_OUT'
export const REFRESH_AUTHORIZATION = 'REFRESH_AUTHORIZATION'
export const SAVE_SESSION_EXPIRED_ACTION = 'SAVE_SESSION_EXPIRED_ACTION'
export const CLEAR_SESSION_EXPIRED_ACTIONS = 'CLEAR_SESSION_EXPIRED_ACTIONS'
export const LOG_IN_FAILURE = 'LOG_IN_FAILURE'
export const LOG_IN_ERROR_RESET = 'LOG_IN_ERROR_RESET'
export const SET_SORTING = 'SET_SORTING'
export const UPDATE_PAGE = 'UPDATE_PAGE'
export const SET_LAST_PAGE = 'SET_LAST_PAGE'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SOFT_RESET_STUDENT_LIST = 'SOFT_RESET_STUDENT_LIST'
export const SET_TOTAL_ELEMENTS = 'SET_TOTAL_ELEMENTS'
export const CONFIG_FETCH_SUCCESS = 'CONFIG_FETCH_SUCCESS'
export const CONFIG_FETCH_FAILED = 'CONFIG_FETCH_FAILED'
export const SET_STUDENT_LIST_SCROLL_TOP = 'SET_STUDENT_LIST_SCROLL_TOP'
export const RESET_STUDENTS_MODULE = 'RESET_STUDENTS_MODULE'
export const LOGOUT_SNACKBAR_OFF = 'LOGOUT_SNACKBAR_OFF'
export const SET_PROFILE_DARK_THEME = 'SET_PROFILE_DARK_THEME'
export const SET_PREVIOUS_ROUTE = 'SET_PREVIOUS_ROUTE'
export const DECREMENT_SSO_REFRESH_FREQUENCY = 'DECREMENT_SSO_REFRESH_FREQUENCY'
export const RESET_SSO_REFRESH_ATTEMPTS = 'RESET_SSO_REFRESH_ATTEMPTS'
export const SET_DOMAIN_NAME = 'SET_DOMAIN_NAME'
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_LANGUAGE_LIST = 'SET_LANGUAGE_LIST'
export const SET_SELECTED_STUDENTS_COUNT = 'SET_SELECTED_STUDENTS_COUNT'
export const SET_ALL_STUDENTS_SELECTED = 'SET_ALL_STUDENTS_SELECTED'
export const SET_ALL_STUDENTS_UNSELECTED = 'SET_ALL_STUDENTS_UNSELECTED'
export const SET_REMOVE_STUDENT_FROM_REMOVED_STUDENTS_LIST = 'SET_REMOVE_STUDENT_FROM_REMOVED_STUDENTS_LIST'
export const SET_SELECT_LOADING = 'SET_SELECT_LOADING'
export const SET_LOGIN_LOADING = 'SET_LOGIN_LOADING'
export const SET_PERSONAL_MENU = 'SET_PERSONAL_MENU'
export const SET_HELP_MENU_FLAG = 'SET_HELP_MENU_FLAG'

// Student specific
export const SET_STUDENT = 'SET_STUDENT'
export const RESET_STUDENT = 'RESET_STUDENT'
export const SET_STUDENT_ENGAGEMENT = 'SET_STUDENT_ENGAGEMENT'
export const SET_STUDENT_ENGAGEMENT_SUMMARY = 'SET_STUDENT_ENGAGEMENT_SUMMARY'
export const SET_STUDENT_PROFILE = 'SET_STUDENT_PROFILE'
export const SET_STUDENT_COURSE_AVERAGE = 'SET_STUDENT_COURSE_AVERAGE'
export const SET_STUDENT_COURSE_TOP = 'SET_STUDENT_COURSE_TOP'
export const SET_INTERVENTION_SHOW_STATE = 'SET_INTERVENTION_SHOW_STATE'
export const SET_STUDENT_INTERVENTIONS = 'SET_STUDENT_INTERVENTIONS'
export const SET_STUDENT_MODULES = 'SET_STUDENT_MODULES'
export const SOFT_RESET_STUDENT_MODULES = 'SOFT_RESET_STUDENT_MODULES'
export const REPLACE_STUDENT_INTERVENTIONS = 'REPLACE_STUDENT_INTERVENTIONS'
export const SET_STUDENT_LIST_SEARCH_FIELD = 'SET_STUDENT_LIST_SEARCH_FIELD'
export const SET_STUDENT_LIST_SEARCH_FIELD_DISPLAY = 'SET_STUDENT_LIST_SEARCH_FIELD_DISPLAY'
export const SET_STUDENT_CALENDAR_DATA = 'SET_STUDENT_CALENDAR_DATA'
export const SET_STUDENT_EXEMPTIONS = 'SET_STUDENT_EXEMPTIONS'
export const SET_STUDENT_INTERVENTIONS_LOADING = 'SET_STUDENT_INTERVENTIONS_LOADING'
export const TOGGLE_STUDENTS_LIST_FILTER = 'TOGGLE_STUDENTS_LIST_FILTER'
export const SET_STUDENTS_LIST_FILTER_ARRAY = 'SET_STUDENTS_LIST_FILTER_ARRAY'
export const SET_STUDENTS_LIST_IS_FILTERING = 'SET_STUDENTS_LIST_IS_FILTERING'
export const SET_COURSES_FOR_STUDENTS = 'SET_COURSES_FOR_STUDENTS'
export const CLEAR_STUDENTS_LIST_FILTERS = 'CLEAR_STUDENTS_LIST_FILTERS'
export const CLEAR_CUSTOM_FILTERS = 'CLEAR_CUSTOM_FILTERS'
export const SET_GRAPH_INTERVENTIONS = 'SET_GRAPH_INTERVENTIONS'
export const SET_GRAPH_ALERTS = 'SET_GRAPH_ALERTS'
export const SET_GRAPH_EXEMPTIONS_DRAWN = 'SET_GRAPH_EXEMPTIONS_DRAWN'
export const SET_GRAPH_COURSE_CHANGE = 'SET_GRAPH_COURSE_CHANGE'
export const SET_STUDENT_AVERAGE_ATTENDANCE = 'SET_STUDENT_AVERAGE_ATTENDANCE'
export const SET_STUDENT_COURSE_AVERAGE_ATTENDANCE = 'SET_STUDENT_COURSE_AVERAGE_ATTENDANCE'
export const SET_STUDENT_GRAPH_INTERACTIONS = 'SET_STUDENT_GRAPH_INTERACTIONS'
export const SET_STUDENT_GRAPH_DATA_LOADED = 'SET_STUDENT_GRAPH_DATA_LOADED'
export const SET_STUDENT_CUSTOM_BUTTON_FILTER_TYPE = 'SET_STUDENT_CUSTOM_BUTTON_FILTER_TYPE'
export const SET_STUDENT_CUSTOM_LIST_FILTER_TYPE = 'SET_STUDENT_CUSTOM_LIST_FILTER_TYPE'
export const SET_STUDENT_BUTTON_FILTER_TYPE = 'SET_STUDENT_BUTTON_FILTER_TYPE'
export const STUDENTS_REMOVED_FROM_GROUP = 'STUDENTS_REMOVED_FROM_GROUP'
export const STUDENTS_ADDED_TO_SELECTED_GROUP = 'STUDENTS_ADDED_TO_SELECTED_GROUP'
export const SET_STUDENT_LIST_FILTER_TYPE = 'SET_STUDENT_LIST_FILTER_TYPE'
export const SOFT_RESET_STUDENT_ENGAGEMENT = 'SOFT_RESET_STUDENT_ENGAGEMENT'
export const SET_SAVED_FILTERS_FOR_STAFF = 'SET_SAVED_FILTERS_FOR_STAFF'
export const HIDE_SAVED_FILTER_BY_ID = 'HIDE_SAVED_FILTER_BY_ID'
export const SHOW_SAVED_FILTER_BY_ID = 'SHOW_SAVED_FILTER_BY_ID'
export const SAVE_DELETED_FILTER_ID = 'SAVE_DELETED_FILTER_ID'
export const STUDENT_REPORT_LOADING = 'STUDENT_REPORT_LOADING'
export const STUDENT_REPORT_LOADING_LABEL = 'STUDENT_REPORT_LOADING_LABEL'
export const STUDENT_REPORT_FINISHED_LOADING = 'STUDENT_REPORT_FINISHED_LOADING'
export const STUDENT_REPORT_FINISHED_LABEL = 'STUDENT_REPORT_FINISHED_LABEL'
export const HOLD_DEFAULT_SEARCH = 'HOLD_DEFAULT_SEARCH'
export const SET_SELECTED_DEFAULT_FILTER = 'SET_SELECTED_DEFAULT_FILTER'
export const HIDE_CHART_FILTERS = 'HIDE_CHART_FILTERS'
export const BUILD_MY_STUDENT_ELEMENTS = 'BUILD_MY_STUDENT_ELEMENTS'
export const SET_MY_STUDENT_COLUMNS = 'SET_MY_STUDENT_COLUMNS'
export const SET_ACTIVE_TAB_WITH_CODE_TO_SEARCH = 'SET_ACTIVE_TAB_WITH_CODE_TO_SEARCH'
export const RESET_ACTIVE_TAB_WITH_CODE_TO_SEARCH = 'RESET_ACTIVE_TAB_WITH_CODE_TO_SEARCH'
export const SET_STUDENT_ACCESSIBILITY = 'SET_STUDENT_ACCESSIBILITY'
export const SET_STUDENT_CUMULATIVE_ENGAGEMENT = 'SET_STUDENT_CUMULATIVE_ENGAGEMENT'
export const SET_STUDENT_CUMULATIVE_COURSE_AVERAGE = 'SET_STUDENT_CUMULATIVE_COURSE_AVERAGE'
export const SET_STUDENT_CUMULATIVE_COURSE_TOP = 'SET_STUDENT_CUMULATIVE_COURSE_TOP'
export const SET_DEFAULT_MYGROUP_ID = 'SET_DEFAULT_MYGROUP_ID'
export const UNSET_DEFAULT_MYGROUP_ID = 'UNSET_DEFAULT_MYGROUP_ID'
export const UNSET_SELECTED_GROUP = 'UNSET_SELECTED_GROUP'
export const SET_MY_GROUPS_FILTER = 'SET_MY_GROUPS_FILTER'
export const SWITCH_TABLE_MODE = 'SWITCH_TABLE_MODE'
export const SET_SELECTED_FILTER_ID = 'SET_SELECTED_FILTER_ID'
export const SET_CURRENT_ACCESSIBILITY_FLAG = 'SET_CURRENT_ACCESSIBILITY_FLAG'
export const UNCHECK_DEFAULT_FILTER = 'UNCHECK_DEFAULT_FILTER'

// Staff specific
export const SET_IS_TUTOR = 'SET_IS_TUTOR'
export const SET_TUTOR_FILTER_CHANGE = 'SET_TUTOR_FILTER_CHANGE'

// Right drawer specific
export const SET_DRAWER_STATE = 'SET_DRAWER_STATE'
export const SET_DRAWER_COMPONENT = 'SET_DRAWER_COMPONENT'
export const SET_DRAWER_COMPONENT_TITLE = 'SET_DRAWER_COMPONENT_TITLE'

// Hierarchy specific
export const SET_ALERT_HIERARCHY_DRAWER_STATE = 'SET_ALERT_HIERARCHY_DRAWER_STATE'
export const SET_CLASS_HIERARCHY = 'SET_CLASS_HIERARCHY'
export const SET_CLASS_HIERARCHY_OPEN = 'SET_CLASS_HIERARCHY_OPEN'
export const SET_CLASS_HIERARCHY_TICK = 'SET_CLASS_HIERARCHY_TICK'
export const SET_CLASS_HIERARCHY_SELECTIONS = 'SET_CLASS_HIERARCHY_SELECTIONS'
export const SET_COURSE_HIERARCHY_LOADING = 'SET_COURSE_HIERARCHY_LOADING'
export const SET_RAW_HIERARCHY = 'SET_RAW_HIERARCHY'

// Create intervention specific
export const SET_INTERVENTION_CATEGORY = 'SET_INTERVENTION_CATEGORY'
export const SET_INTERVENTION_STUDENT = 'SET_INTERVENTION_STUDENT'
export const SET_INTERVENTION_COMMUNICATION = 'SET_INTERVENTION_COMMUNICATION'
export const SET_INTERVENTION_REMINDER_DAYS = 'SET_INTERVENTION_REMINDER_DAYS'
export const SET_INTERVENTION_REPEATING_EMAIL = 'SET_INTERVENTION_REPEATING_EMAIL'
export const SET_INTERVENTION_DATE = 'SET_INTERVENTION_DATE'
export const SET_INTERVENTION_COMMUNICATION_DATE = 'SET_INTERVENTION_COMMUNICATION_DATE'
export const SET_INTERVENTION_REPEATING_EMAIL_END_DATE = 'SET_INTERVENTION_REPEATING_EMAIL_END_DATE'
export const SET_INTERVENTION_DATE_FORMATTED = 'SET_INTERVENTION_DATE_FORMATTED'
export const SET_INTERVENTION_COMMUNICATION_DATE_FORMATTED = 'SET_INTERVENTION_COMMUNICATION_DATE_FORMATTED'
export const SET_INTERVENTION_REPEATING_EMAIL_END_DATE_FORMATTED = 'SET_INTERVENTION_REPEATING_EMAIL_END_DATE_FORMATTED'
export const SET_INTERVENTION_ACTION = 'SET_INTERVENTION_ACTION'
export const SET_INTERVENTION_MODE = 'SET_INTERVENTION_MODE'
export const SET_EXEMPTION_MODE = 'SET_EXEMPTION_MODE'
export const SET_INTERVENTION_SUMMARY = 'SET_INTERVENTION_SUMMARY'
export const RESET_INTERVENTION_MODULE = 'RESET_INTERVENTION_MODULE'
export const SET_INTERVENTION_STUDENTS = 'SET_INTERVENTION_STUDENTS'
export const INTERVENTION_STUDENTS_LIST_LOADING = 'INTERVENTION_STUDENTS_LIST_LOADING'
export const INTERVENTION_STUDENTS_LIST_NOT_LOADING = 'INTERVENTION_STUDENTS_LIST_NOT_LOADING'
export const SET_INTERVENTION_FORM_VALID = 'SET_INTERVENTION_FORM_VALID'
export const SET_INTERVENTION_CATEGORY_LIST = 'SET_INTERVENTION_CATEGORY_LIST'
export const SET_INTERVENTION_COMMUNICATION_LIST = 'SET_INTERVENTION_COMMUNICATION_LIST'
export const SET_INTERVENTION_CLOSURE_LIST = 'SET_INTERVENTION_CLOSURE_LIST'
export const SET_INTERVENTION_REFERRAL_LIST = 'SET_INTERVENTION_REFERRAL_LIST'
export const SET_INTERVENTION_SENDING = 'SET_INTERVENTION_SENDING'
export const SET_INTERVENTION_REFERRAL = 'SET_INTERVENTION_REFERRAL'
export const ADD_INTERVENTION_REFERRAL = 'ADD_INTERVENTION_REFERRAL '
export const REMOVE_INTERVENTION_REFERRAL = 'REMOVE_INTERVENTION_REFERRAL'
export const SET_INTERVENTION_REFERRAL_ID = 'SET_INTERVENTION_REFERRAL_ID'
export const SET_INTERVENTION_REFERRAL_SUMMARY = 'SET_INTERVENTION_REFERRAL_SUMMARY'
export const SET_INTERVENTION_REFERRAL_RECIPIENTS = 'SET_INTERVENTION_REFERRAL_RECIPIENTS'
export const SET_INTERVENTION_DURATION = 'SET_INTERVENTION_DURATION'
export const SET_INTERVENTION_DESCRIPTION = 'SET_INTERVENTION_DESCRIPTION'
export const SET_INTERVENTION_CLOSE_ON_CREATE = 'SET_INTERVENTION_CLOSE_ON_CREATE'
export const SET_INTERVENTION_CONSENT = 'SET_INTERVENTION_CONSENT'
export const EDIT_INTERVENTION = 'EDIT_INTERVENTION'
export const HANDLE_UPDATE_INTERVENTION_RESPONSE = 'HANDLE_UPDATE_INTERVENTION_RESPONSE'
export const ADD_COMMENT_TO_INTERVENTION = 'ADD_COMMENT_TO_INTERVENTION'
export const RESET_AND_SCROLL_INTERVENTION = 'RESET_AND_SCROLL_INTERVENTION'
export const STUDENT_INTERVENTIONS_OPEN_BY_ID = 'STUDENT_INTERVENTIONS_OPEN_BY_ID'
export const SAVE_DELETED_INTERVENTION_ID = 'SAVE_DELETED_INTERVENTION_ID'
export const HIDE_INTERVENTION_BY_ID = 'HIDE_INTERVENTION_BY_ID'
export const SHOW_INTERVENTION_BY_ID = 'SHOW_INTERVENTION_BY_ID'
export const SET_INTERVENTION_COUNT = 'SET_INTERVENTION_COUNT'
// Information 'channel' specific
export const SET_INFORMATION_SNACKBAR_STATE = 'SET_INFORMATION_SNACKBAR_STATE'
export const SET_INFORMATION_SNACKBAR_TEXT = 'SET_INFORMATION_SNACKBAR_TEXT'
export const SET_INFORMATION_TOASTER_STATE = 'SET_INFORMATION_TOASTER_STATE'
export const SET_INFORMATION_TOASTER_TEXT = 'SET_INFORMATION_TOASTER_TEXT'
export const SET_INFORMATION_DISPLAYED_LIST = 'SET_INFORMATION_DISPLAYED_LIST'

// Interventions specific
export const INTERACTIONS_LIST_LOADING = 'INTERACTIONS_LIST_LOADING'
export const INTERACTIONS_LIST_NOT_LOADING = 'INTERACTIONS_LIST_NOT_LOADING'
export const SET_SELECTED_RECIPIENT_USER_TYPES = 'SET_SELECTED_RECIPIENT_USER_TYPES'
export const SET_INTERVENTION_RECIPIENT_TYPES = 'SET_INTERVENTION_RECIPIENT_TYPES'
export const CONCAT_INTERVENTION_RECIPIENT_TYPES = 'CONCAT_INTERVENTION_RECIPIENT_TYPES'
export const SET_INTERVENTION_INVALID_EMAIL_STATUS = 'SET_INTERVENTION_INVALID_EMAIL_STATUS'
export const RESET_INTERVENTION_RECIPIENT_TYPES = 'RESET_INTERVENTION_RECIPIENT_TYPES'

export const EMPTY_INTERACTIONS_LIST = 'EMPTY_INTERACTIONS_LIST'
export const SET_INTERACTIONS_TRANSITION = 'SET_INTERACTIONS_TRANSITION'
export const TOGGLE_INTERACTIONS_LIST_FILTER = 'TOGGLE_INTERACTIONS_LIST_FILTER'
export const CLEAR_INTERACTIONS_LIST_FILTERS = 'CLEAR_INTERACTIONS_LIST_FILTERS'
export const SOFT_RESET_STUDENT_INTERVENTION = 'SOFT_RESET_STUDENT_INTERVENTION'

// Interactions specific
export const SET_INTERACTIONS_LIST = 'SET_INTERACTIONS_LIST'
export const UPDATE_INTERACTIONS_LIST = 'UPDATE_INTERACTIONS_LIST'
export const SET_INTERACTIONS_LIST_SCROLL_TOP = 'SET_INTERACTIONS_LIST_SCROLL_TOP'
export const INTERACTIONS_DATE_FILTER_CHANGE = 'INTERACTIONS_DATE_FILTER_CHANGE'
export const INTERACTIONS_DATE_AND_FILTER_RESET = 'INTERACTIONS_DATE_AND_FILTER_RESET'
export const SET_INTERACTIONS_LOADED = 'SET_INTERACTIONS_LOADED'
export const SET_INTERACTIONS_SORTING = 'SET_INTERACTIONS_SORTING'
export const RESET_INTERACTIONS_MODULE = 'RESET_INTERACTIONS_MODULE'
export const SET_INTERACTIONS_PAGE_SIZE = 'SET_INTERACTIONS_PAGE_SIZE'
export const SET_INTERACTIONS_PAGE_NUMBER = 'SET_INTERACTIONS_PAGE_NUMBER'
export const REPLACE_INTERACTIONS = 'REPLACE_INTERACTIONS'
export const SET_INTERACTIONS_TOTAL_ELEMENTS = 'SET_INTERACTIONS_TOTAL_ELEMENTS'

// Undo specific
export const SET_UNDO_STATE_SYNC = 'SET_UNDO_STATE_SYNC'
export const SET_UNDO_TYPE = 'SET_UNDO_TYPE'

// Close Interventions specific
export const SET_CLOSE_INTERVENTION_FORM_VALID = 'SET_CLOSE_INTERVENTION_FORM_VALID'
export const SET_CLOSE_INTERVENTION_FORM_INTERVENTION = 'SET_CLOSE_INTERVENTION_FORM_INTERVENTION'
export const UPDATED_INTERVENTION = 'UPDATED_INTERVENTION'

// Admin specific
export const TOGGLE_ADMIN_ALERT_STATE = 'TOGGLE_ADMIN_ALERT_STATE'
export const SET_ADMIN_ALERT_SLIDER = 'SET_ADMIN_ALERT_SLIDER'
export const SET_ADMIN_ALERT_DAYS = 'SET_ADMIN_ALERT_DAYS'
export const SET_ADMIN_ALERT_DATE_RANGE = 'SET_ADMIN_ALERT_DATE_RANGE'
export const UPDATE_ADMIN_ALERT_EMAIL_RECIPIENTS = 'UPDATE_ADMIN_ALERT_EMAIL_RECIPIENTS'
export const UPDATE_ADMIN_ALERT_EMAIL_TEXT = 'UPDATE_ADMIN_ALERT_EMAIL_TEXT'
export const SET_ADMIN_ALERT_NAME = 'SET_ADMIN_ALERT_NAME'
export const SET_ADMIN_ALERT_ACTIVE = 'SET_ADMIN_ALERT_ACTIVE'
export const POPULATE_ADMIN_ALERTS = 'POPULATE_ADMIN_ALERTS'
export const SET_ADMIN_ALERT_START_DATE = 'SET_ADMIN_ALERT_START_DATE'
export const SET_ADMIN_ALERT_END_DATE = 'SET_ADMIN_ALERT_END_DATE'
export const SET_ADMIN_ALERT_LAST_UPDATED = 'SET_ADMIN_ALERT_LAST_UPDATED'
export const POPULATE_ADMIN_ALERT_EMAILS = 'POPULATE_ADMIN_ALERT_EMAILS'
export const ADD_EMAIL_TEMPLATE_TO_ALERT = 'ADD_EMAIL_TEMPLATE_TO_ALERT'
export const ADD_EMAIL_TEMPLATE_TO_EMAILS_ARRAY = 'ADD_EMAIL_TEMPLATE_TO_EMAILS_ARRAY'
export const SET_ADMIN_ALERT_EMAIL_EDITED_STATE = 'SET_ADMIN_ALERT_EMAIL_EDITED_STATE'
export const HIDE_ADMIN_ALERT_EMAIL_BY_ID = 'HIDE_ADMIN_ALERT_EMAIL_BY_ID'
export const SHOW_ADMIN_ALERT_EMAIL_BY_ID = 'SHOW_ADMIN_ALERT_EMAIL_BY_ID'
export const SET_LAST_DELETED_ADMIN_ALERT_EMAIL_ID = 'SET_LAST_DELETED_ADMIN_ALERT_EMAIL_ID'
export const SET_ADMIN_ALERT_AFFECTED_COUNT = 'SET_ADMIN_ALERT_AFFECTED_COUNT'
export const SET_ALERT_EDITING = 'SET_ALERT_EDITING'
export const SET_ALERT_COURSES = 'SET_ALERT_COURSES'
export const SET_ALERT_ACADEMIC_YEAR = 'SET_ALERT_ACADEMIC_YEAR'
export const SET_ALERT_ENROLMENT_STATUS = 'SET_ALERT_ENROLMENT_STATUS'
export const SET_STUDY_MODE_FOR_ALERT_FROM_CHANGE = 'SET_STUDY_MODE_FOR_ALERT_FROM_CHANGE'
export const SET_ALERT_COURSE_LEVEL = 'SET_ALERT_COURSE_LEVEL'
export const SET_CUSTOM_ALERT_FILTERS = 'SET_CUSTOM_ALERT_FILTERS'
export const UPDATE_ALERT = 'UPDATE_ALERT'
export const SET_ALERT_BUTTON_FILTER_TYPE = 'SET_ALERT_BUTTON_FILTER_TYPE'
export const SET_ALERT_LIST_FILTER_TYPE = 'SET_ALERT_LIST_FILTER_TYPE'
export const SET_ALERT_CUSTOM_BUTTON_FILTER_TYPE = 'SET_ALERT_CUSTOM_BUTTON_FILTER_TYPE'
export const SET_ALERT_CUSTOM_LIST_FILTER_TYPE = 'SET_ALERT_CUSTOM_LIST_FILTER_TYPE'
export const SET_ALERT_LIST_FILTER_ARRAY = 'SET_ALERT_LIST_FILTER_ARRAY'
export const TOGGLE_ALERTS_FILTER = 'TOGGLE_ALERTS_FILTER'
export const SET_ALERT_FILTER_ID = 'SET_ALERT_FILTER_ID'
export const SET_CUSTOM_FILTERS_ARRAY = 'SET_CUSTOM_FILTERS_ARRAY'
export const SET_ALERT_BUTTON_FILTER_ARRAY = 'SET_ALERT_BUTTON_FILTER_ARRAY'
export const RESET_ALERT_FILTERS = 'RESET_ALERT_FILTERS'
export const SET_REORDER_CHART_DIALOG_VISIBILITY = 'SET_REORDER_CHART_DIALOG_VISIBILITY'
export const SET_CREATE_CHART_DIALOG_VISIBILITY = 'SET_CREATE_CHART_DIALOG_VISIBILITY'

// Alert specific
export const SET_ALERT_ID = 'SET_ALERT_ID'
export const SET_ALERT_ACTIVE_TOGGLE = 'SET_ALERT_ACTIVE_TOGGLE'
export const SET_LANDING_ALERTS = 'SET_LANDING_ALERTS'
export const SET_LANDING_ALERTS_PROGRESS_ON = 'SET_LANDING_ALERTS_PROGRESS_ON'
export const SET_LANDING_ALERTS_PROGRESS_OFF = 'SET_LANDING_ALERTS_PROGRESS_OFF'
export const SET_SINGLE_ALERT = 'SET_SINGLE_ALERT'
export const RESET_SINGLE_ALERT = 'RESET_SINGLE_ALERT'
export const UPDATE_ALERT_DETAILS = 'UPDATE_ALERT_DETAILS'
export const SET_ALERT_START_DATE = 'SET_ALERT_START_DATE'
export const SET_ALERT_END_DATE = 'SET_ALERT_END_DATE'
export const SET_ALERT_DESCRIPTION = 'SET_ALERT_DESCRIPTION'
export const SET_ALERT_DETAILS_DESCRIPTION = 'SET_ALERT_DETAILS_DESCRIPTION'
export const UPDATE_ALERT_LIST = 'UPDATE_ALERT_LIST'
export const SAVE_LAST_DELETED_ALERT_ID = 'SAVE_LAST_DELETED_ALERT_ID'
export const HIDE_ALERT_BY_ID = 'HIDE_ALERT_BY_ID'
export const SHOW_ALERT_BY_ID = 'SHOW_ALERT_BY_ID'
export const SET_STUDENT_AFFECTED_COUNT = 'SET_STUDENT_AFFECTED_COUNT'
export const SET_ALERT_DETAILS_ACTIVE_TOGGLE = 'SET_ALERT_DETAILS_ACTIVE_TOGGLE'
export const SET_AFFECTED_STUDENTS_PROGRESS_ON = 'SET_AFFECTED_STUDENTS_PROGRESS_ON'

export const SET_AFFECTED_STUDENT_REQUEST_CANCEL_TOKEN = 'SET_AFFECTED_STUDENT_REQUEST_CANCEL_TOKEN'
export const SET_AFFECTED_STUDENTS_PROGRESS_OFF = 'SET_AFFECTED_STUDENTS_PROGRESS_OFF'
export const SET_ALERT_CONSECUTIVE_DAYS = 'SET_ALERT_CONSECUTIVE_DAYS'
export const SET_ALERT_DATE_RANGE = 'SET_ALERT_DATE_RANGE'
export const CREATE_NEW_DEFAULT_ALERT = 'CREATE_NEW_DEFAULT_ALERT'
export const ALERT_DETAILS_PANEL_DISPLAY_FLAG = 'ALERT_DETAILS_PANEL_DISPLAY_FLAG'
export const CLEAR_ALERT_FILTERS = 'CLEAR_ALERT_FILTERS'
export const SET_COURSES_FOR_ALERTS_FROM_ENDPOINT = 'SET_COURSES_FOR_ALERTS_FROM_ENDPOINT'
export const SET_COURSES_FOR_ALERTS_FROM_CHANGE = 'SET_COURSES_FOR_ALERTS_FROM_CHANGE'
export const SET_ALERT_DETAILS_BODY_PROGRESS_ON = 'SET_ALERT_DETAILS_BODY_PROGRESS_ON'
export const SET_ALERT_DETAILS_BODY_PROGRESS_OFF = 'SET_ALERT_DETAILS_BODY_PROGRESS_OFF'
export const SET_TOTAL_ALERTS = 'SET_TOTAL_ALERTS'
export const SET_ALERT_SEARCH = 'SET_ALERT_SEARCH'

// Alert frequency specific
export const SELECT_ALL_FREQUENCY = 'SELECT_ALL_FREQUENCY'
export const SELECT_FREQUENCY_ITEMS = 'SELECT_FREQUENCY_ITEMS'
export const SELECT_ALERT_POSITIVE = 'SELECT_ALERT_POSITIVE'

// Alert DataSet specific
export const SET_DATA_SET_ITEMS = 'SET_DATA_SET_ITEMS'
export const SHOW_ALL_DATA_SETS = 'SHOW_ALL_DATA_SETS'
export const SET_DATA_SET_ITEM_VISIBILITY = 'SET_DATA_SET_ITEM_VISIBILITY'
export const UPDATE_DATA_SET_PROP = 'UPDATE_DATA_SET_PROP'
export const RESET_DATA_SET_VALUES = 'RESET_DATA_SET_VALUES'
export const CREATE_NEW_DATA_SET_ITEM = 'CREATE_NEW_DATA_SET_ITEM'
export const UNDO_CREATE_NEW_DATA_SET_ITEM = 'UNDO_CREATE_NEW_DATA_SET_ITEM'
export const UPDATE_NEW_LOGIC_COLOUR_GROUP = 'UPDATE_NEW_LOGIC_COLOUR_GROUP'
export const UPDATE_EXISTING_LOGIC_COLOUR_GROUP = 'UPDATE_EXISTING_LOGIC_COLOUR_GROUP'
export const SAVE_LAST_DELETED_DATA_SET_ID = 'SAVE_LAST_DELETED_DATA_SET_ID'
export const HIDE_DATA_SET_BY_ID = 'HIDE_DATA_SET_BY_ID'
export const SHOW_DATA_SET_BY_ID = 'SHOW_DATA_SET_BY_ID'
export const SET_DATA_SET_PROPERTIES = 'SET_DATA_SET_PROPERTIES'
export const SET_DATA_SET_PROGRESS_ON = 'SET_DATA_SET_PROGRESS_ON'
export const SET_DATA_SET_PROGRESS_OFF = 'SET_DATA_SET_PROGRESS_OFF'

// Alert template specific
export const SET_ALERT_PLACEHOLDERS = 'SET_ALERT_PLACEHOLDERS'
export const PLACEHOLDER_COPY_TO_CLIPBOARD = 'PLACEHOLDER_COPY_TO_CLIPBOARD'
export const PLACEHOLDER_RESET_CLIPBOARD = 'PLACEHOLDER_RESET_CLIPBOARD'
export const SHOW_ALL_TEMPLATES = 'SHOW_ALL_TEMPLATES'
export const SET_TEMPLATE_ITEM_VISIBILITY = 'SET_TEMPLATE_ITEM_VISIBILITY'
export const UPDATE_TEMPLATE_PROP = 'UPDATE_TEMPLATE_PROP'
export const SAVE_LAST_DELETED_EMAIL_TEMPLATE_ID = 'SAVE_LAST_DELETED_EMAIL_TEMPLATE_ID'
export const HIDE_EMAIL_TEMPLATE_BY_ID = 'HIDE_EMAIL_TEMPLATE_BY_ID'
export const SHOW_EMAIL_TEMPLATE_BY_ID = 'SHOW_EMAIL_TEMPLATE_BY_ID'
export const CREATE_NEW_EMAIL_TEMPLATE_ITEM = 'CREATE_NEW_EMAIL_TEMPLATE_ITEM'
export const REMOVE_EMAIL_TEMPLATE_ITEM = 'REMOVE_EMAIL_TEMPLATE_ITEM'
export const REMOVE_DATA_SET_ITEM = 'REMOVE_DATA_SET_ITEM'
export const UNDO_CREATE_NEW_EMAIL_TEMPLATE_ITEM = 'UNDO_CREATE_NEW_EMAIL_TEMPLATE_ITEM'
export const UPDATE_NEW_EMAIL_TEMPLATE = 'UPDATE_NEW_EMAIL_TEMPLATE'
export const SET_EMAIL_TEMPLATE_DELIVERY_METHOD = 'SET_EMAIL_TEMPLATE_DELIVERY_METHOD'
export const SET_TEMPLATES_PROGRESS_ON = 'SET_TEMPLATES_PROGRESS_ON'
export const SET_TEMPLATES_PROGRESS_OFF = 'SET_TEMPLATES_PROGRESS_OFF'
export const UNDO_CREATE_NEW_TEMPLATE_ITEM = 'UNDO_CREATE_NEW_TEMPLATE_ITEM'
export const SET_DELIVERY_METHODS = 'SET_DELIVERY_METHODS'
export const CONCAT_TEMPLATE_RECIPIENT_TYPES = 'CONCAT_TEMPLATE_RECIPIENT_TYPES'

// Exemption specific
export const SET_EXEMPTION_REASONS_LIST = 'SET_EXEMPTION_REASONS_LIST'
export const EDIT_EXEMPTION = 'EDIT_EXEMPTION'
export const SET_EXEMPTION_REASON = 'SET_EXEMPTION_REASON'
export const SET_EXEMPTION_START_DATE = 'SET_EXEMPTION_START_DATE'
export const SET_EXEMPTION_END_DATE = 'SET_EXEMPTION_END_DATE'
export const SET_EXEMPTION_START_DISABLED = 'SET_EXEMPTION_START_DISABLED'
export const SET_EXEMPTION_END_DISABLED = 'SET_EXEMPTION_END_DISABLED'
export const SET_EXEMPTION_ID = 'SET_EXEMPTION_ID'
export const SET_EXEMPTION_SENDING = 'SET_EXEMPTION_SENDING'
export const UPDATE_EXEMPTION_MUTATION = 'UPDATE_EXEMPTION_MUTATION'
export const DELETE_EXEMPTION_MUTATION = 'DELETE_EXEMPTION_MUTATION'
export const SET_EXEMPTION_ERROR = 'SET_EXEMPTION_ERROR'
export const RESET_EXEMPTION_MODULE = 'RESET_EXEMPTION_MODULE'

// Dashboard specific
export const SET_STUDENTS_COUNT = 'SET_STUDENTS_COUNT'
export const SET_STUDENTS_RATINGS_COUNT = 'SET_STUDENTS_RATINGS_COUNT'
export const SET_DASHBOARD_ALERTS = 'SET_DASHBOARD_ALERTS'
export const SET_DASHBOARD_LAST_SUCCESSFUL_JOBS = 'SET_DASHBOARD_LAST_SUCCESSFUL_JOBS'
export const SET_ENGAGEMENT_LAST_SUCCESSFUL = 'SET_ENGAGEMENT_LAST_SUCCESSFUL'
export const RESET_DASHBOARD_MODULE = 'RESET_DASHBOARD_MODULE'
export const DASHBOARD_LOADING = 'DASHBOARD_LOADING'
export const TOGGLE_DASHBOARD_FILTER = 'TOGGLE_DASHBOARD_FILTER'
export const CLEAR_DASHBOARD_FILTERS = 'CLEAR_DASHBOARD_FILTERS'
export const SET_DASHBOARD_AVAILABLE_CHARTS = 'SET_DASHBOARD_AVAILABLE_CHARTS'
export const SET_DASHBOARD_PRE_RENDER_GRAPHS = 'SET_DASHBOARD_PRE_RENDER_GRAPHS'
export const SET_DASHBOARD_GRAPHS = 'SET_DASHBOARD_GRAPHS'
export const REFRESH_PRIMARY_DASHBOARD_GRAPHS_SEQUENCE = 'REFRESH_PRIMARY_DASHBOARD_GRAPHS_SEQUENCE'
export const REFRESH_SECONDARY_DASHBOARD_GRAPHS_SEQUENCE = 'REFRESH_SECONDARY_DASHBOARD_GRAPHS_SEQUENCE'
export const RESET_DASHBOARD_GRAPHS_SEQUENCE = 'RESET_DASHBOARD_GRAPHS_SEQUENCE'
export const APPEND_DASHBOARD_GRAPH = 'APPEND_DASHBOARD_GRAPH'
export const RESET_DASHBOARD_GRAPHS_DATA = 'RESET_DASHBOARD_GRAPHS_DATA'
export const SET_DASHBOARD_GRAPHS_DATA = 'SET_DASHBOARD_GRAPHS_DATA'
export const APPEND_DASHBOARD_GRAPH_DATA = 'APPEND_DASHBOARD_GRAPH_DATA'
export const UPDATE_DASHBOARD_GRAPH_DATA = 'UPDATE_DASHBOARD_GRAPH_DATA'
export const SET_CHART_FILTER_START_DATE = 'SET_CHART_FILTER_START_DATE'
export const SET_CHART_FILTER_END_DATE = 'SET_CHART_FILTER_END_DATE'
export const SET_CHART_CUSTOM_BUTTON_FILTER_TYPE = 'SET_CHART_CUSTOM_BUTTON_FILTER_TYPE'
export const SET_CHART_CUSTOM_LIST_FILTER_TYPE = 'SET_CHART_CUSTOM_LIST_FILTER_TYPE'
export const SET_CHART_BUTTON_FILTER_TYPE = 'SET_CHART_BUTTON_FILTER_TYPE'
export const SET_CHART_LIST_FILTER_TYPE = 'SET_CHART_LIST_FILTER_TYPE'
export const SET_SELECTED_CHART_ID = 'SET_SELECTED_CHART_ID'
export const SET_CHARTS_LIST_FILTER_ARRAY = 'SET_CHARTS_LIST_FILTER_ARRAY'
export const TOGGLE_CHARTS_LIST_FILTER = 'TOGGLE_CHARTS_LIST_FILTER'
export const SET_SAVED_FILTERS_FOR_CHARTS = 'SET_SAVED_FILTERS_FOR_CHARTS'
export const CLEAR_CHART_FILTERS_LIST = 'CLEAR_CHART_FILTERS_LIST'
export const SET_CHART_START_DATE_FILTER = 'SET_CHART_START_DATE_FILTER'
export const SET_CHART_END_DATE_FILTER = 'SET_CHART_END_DATE_FILTER'
export const SET_CHART_LAST_WEEK_NUMBER = 'SET_CHART_LAST_WEEK_NUMBER'
export const REFRESH_CHART_DATES = 'REFRESH_CHART_DATES'
export const SET_CHART_TITLE = 'SET_CHART_TITLE'
export const SET_CHART_UPDATED = 'SET_CHART_UPDATED'
export const SET_UPDATED_CHART_ID = 'SET_UPDATED_CHART_ID'
export const DASHBOARD_CHARTS_LOADING = 'DASHBOARD_CHARTS_LOADING'
export const DASHBOARD_CHARTS_NOT_LOADING = 'DASHBOARD_CHARTS_NOT_LOADING'
export const SET_COURSES_FOR_CHARTS = 'SET_COURSES_FOR_CHARTS'
export const SAVE_DELETED_CHART_ID = 'SAVE_DELETED_CHART_ID'
export const HIDE_CHART_BY_ID = 'HIDE_CHART_BY_ID'
export const SHOW_CHART_BY_ID = 'SHOW_CHART_BY_ID'
export const DASHBOARD_CHARTS_CACHED = 'DASHBOARD_CHARTS_CACHED'
export const DASHBOARD_CHARTS_NOT_CACHED = 'DASHBOARD_CHARTS_NOT_CACHED'
export const SET_CHART_LIMIT_REACHED = 'SET_CHART_LIMIT_REACHED'

// Resource specific
export const SET_RESOURCES_START_DATE = 'SET_RESOURCES_START_DATE'
export const SET_RESOURCES_END_DATE = 'SET_RESOURCES_END_DATE'
export const SET_RESOURCES_LIST = 'SET_RESOURCES_LIST'
export const RESET_RESOURCE_MODULE = 'RESET_RESOURCE_MODULE'
export const SET_RESOURCE_WEIGHTING = 'SET_RESOURCE_WEIGHTING'
export const SET_STUDENT_RESOURCE_HISTORY = 'SET_STUDENT_RESOURCE_HISTORY'
export const SET_STUDENT_RESOURCE_HISTORY_LOADED = 'SET_STUDENT_RESOURCE_HISTORY_LOADED'
export const SET_STUDENT_RESOURCE_HISTORY_LOADING = 'SET_STUDENT_RESOURCE_HISTORY_LOADING'
export const APPEND_STUDENT_RESOURCE_HISTORY = 'APPEND_STUDENT_RESOURCE_HISTORY'
export const SOFT_RESET_RESOURCE_HISTORY = 'SOFT_RESET_RESOURCE_HISTORY'
export const SOFT_RESET_STUDENT_RESOURCE = 'SOFT_RESET_STUDENT_RESOURCE'

// Attendance specific
export const SET_STUDENT_ATTENDANCE_LIST = 'SET_STUDENT_ATTENDANCE_LIST'
export const APPEND_STUDENT_ATTENDANCE_LIST = 'APPEND_STUDENT_ATTENDANCE_LIST'
export const SET_STUDENT_ATTENDANCE_SUMMARY_LIST = 'SET_STUDENT_ATTENDANCE_SUMMARY_LIST'
export const SET_STUDENT_ATTENDANCE_AVERAGE = 'SET_STUDENT_ATTENDANCE_AVERAGE'
export const SET_STUDENT_ATTENDANCE_DATES = 'SET_STUDENT_ATTENDANCE_DATES'
export const SET_STUDENT_ATTENDANCE_STUDENT = 'SET_STUDENT_ATTENDANCE_STUDENT'
export const SET_STUDENT_ATTENDANCE_LIST_LOADING = 'SET_STUDENT_ATTENDANCE_LIST_LOADING'
export const SOFT_RESET_ATTENDANCE_LIST = 'SOFT_RESET_ATTENDANCE_LIST'
export const SET_ATTENDANCE_STUDENT_MODULES = 'SET_ATTENDANCE_STUDENT_MODULES'
export const SET_ATTENDANCE_MODULE = 'SET_ATTENDANCE_MODULE'
export const SET_ATTENDANCE_MODULE_FROM_TAB = 'SET_ATTENDANCE_MODULE_FROM_TAB'
export const APPLY_DATE_RANGE_FILTERS = 'APPLY_DATE_RANGE_FILTERS'
export const SET_DATE_VALIDATION_ERROR = 'SET_DATE_VALIDATION_ERROR'
export const RESET_ATTENDANCE_DATES = 'RESET_ATTENDANCE_DATES'
export const TOGGLE_MODULE_LIST_FILTER = 'TOGGLE_MODULE_LIST_FILTER'
export const CLEAR_MODULE_FILTERS = 'CLEAR_MODULE_FILTERS'
export const SET_STUDENT_AVAILABLE_MODULES = 'SET_STUDENT_AVAILABLE_MODULES'
export const RESET_ATTENDANCE_STUDENT_MODULES = 'RESET_ATTENDANCE_STUDENT_MODULES'
export const RESET_MODULE_FILTERS = 'RESET_MODULE_FILTERS'

// Assessments specific
export const SET_STUDENT_ASSESSMENTS = 'SET_STUDENT_ASSESSMENTS'
export const SET_STUDENT_ASSESSMENTS_SHOW_STATE = 'SET_STUDENT_ASSESSMENTS_SHOW_STATE'
export const SET_STUDENT_ASSESSMENTS_LIST = 'SET_STUDENT_ASSESSMENTS_LIST'
export const SET_STUDENT_ASSESSMENTS_LIST_LOADING = 'SET_STUDENT_ASSESSMENTS_LIST_LOADING'
export const REPLACE_STUDENT_ASSESSMENTS = 'REPLACE_STUDENT_ASSESSMENTS'
export const SET_STUDENT_ASSESSMENTS_LOADING = 'SET_STUDENT_ASSESSMENTS_LOADING'
export const SOFT_RESET_ASSESSMENT_LIST = 'SOFT_RESET_ASSESSMENT_LIST'
export const SET_STUDENT_CURRENT_ASSESSMENTS = 'SET_STUDENT_CURRENT_ASSESSMENTS'
export const SET_ASSESSMENT_STUDENT_MODULES = 'SET_ASSESSMENT_STUDENT_MODULES'
export const SET_ASSESSMENT_MODULE = 'SET_ASSESSMENT_MODULE'
export const SET_ASSESSMENT_MODULE_FROM_TAB = 'SET_ASSESSMENT_MODULE_FROM_TAB'
export const SET_SELECTED_MODULE_ID = 'SET_SELECTED_MODULE_ID'
export const RESET_ASSESSMENT_STUDENT_MODULES = 'RESET_ASSESSMENT_STUDENT_MODULES'

// Feeds specific
export const SET_FEEDS_STATUS = 'SET_FEEDS_STATUS'
export const SET_FEED_ACTIVE_TOGGLE = 'SET_FEED_ACTIVE_TOGGLE'
export const RESET_FEED_DETAILS_DATE_RANGE = 'RESET_FEED_DETAILS_DATE_RANGE'
export const SET_FEED_ERROR_DETAILS_LOADING = 'SET_FEED_ERROR_DETAILS_LOADING'
export const FEED_REPORT_LOADING_LABEL = 'FEED_REPORT_LOADING_LABEL'
export const FEED_REPORT_FINISHED_LABEL = 'FEED_REPORT_FINISHED_LABEL'
export const FEED_REPORT_LOADING = 'FEED_REPORT_LOADING'

// Feeds breakdown specific
export const SET_FEED_BREAKDOWN_INFO = 'SET_FEED_BREAKDOWN_INFO'
export const SET_AUDIT_BREAKDOWN_INFO = 'SET_AUDIT_BREAKDOWN_INFO'
export const SET_FEED_BREAKDOWN_LOADING = 'SET_FEED_BREAKDOWN_LOADING'
export const SET_FEED_BREAKDOWN_LIST_SCROLL_TOP = 'SET_FEED_BREAKDOWN_LIST_SCROLL_TOP'
export const SET_FEED_BREAKDOWN_ID = 'SET_FEED_BREAKDOWN_ID'
export const SET_FEED_BREAKDOWN_DATE_FILTER_CHANGE = 'SET_FEED_BREAKDOWN_DATE_FILTER_CHANGE'
export const CLEAR_FEED_BREAKDOWN_RESULTS = 'CLEAR_FEED_BREAKDOWN_RESULTS'
export const SET_FEED_BREAKDOWN_PROCESS_DATE_CHANGE = 'SET_FEED_BREAKDOWN_PROCESS_DATE_CHANGE'
export const SET_FEED_BREAKDOWN_AUDIT_ID = 'SET_FEED_BREAKDOWN_AUDIT_ID'
export const SET_FEED_CARD_DATA = 'SET_FEED_CARD_DATA'
export const SET_FEED_SCHEDULE_ID = 'SET_FEED_SCHEDULE_ID'
export const SET_FEED_BREAKDOWN_SHOW_STATE = 'SET_FEED_BREAKDOWN_SHOW_STATE'
export const SET_FEED_AUDIT_LOADING = 'SET_FEED_AUDIT_LOADING'
export const SET_FEED_ERROR_DETAILS = 'SET_FEED_ERROR_DETAILS'

// Announcement specific
export const SET_ANNOUNCEMENTS = 'SET_ANNOUNCEMENTS'
export const SET_ALL_ANNOUNCEMENTS = 'SET_ALL_ANNOUNCEMENTS'
export const EDIT_ANNOUNCEMENT = 'EDIT_ANNOUNCEMENT'
export const SET_EDIT_ANNOUNCEMENT_MESSAGE = 'SET_EDIT_ANNOUNCEMENT_MESSAGE'
export const SET_EDIT_ANNOUNCEMENT_ROLES = 'SET_EDIT_ANNOUNCEMENT_ROLES'
export const SET_EDIT_ANNOUNCEMENT_SEVERITY = 'SET_EDIT_ANNOUNCEMENT_SEVERITY'
export const SET_EDIT_ANNOUNCEMENT_START_DATE = 'SET_EDIT_ANNOUNCEMENT_START_DATE'
export const SET_EDIT_ANNOUNCEMENT_END_DATE = 'SET_EDIT_ANNOUNCEMENT_END_DATE'
export const SET_EDIT_ANNOUNCEMENT_STATUS = 'SET_EDIT_ANNOUNCEMENT_STATUS'
export const SET_ANNOUNCEMENT_DIALOG_STATE = 'SET_ANNOUNCEMENT_DIALOG_STATE'
export const NEW_ANNOUNCEMENT_STATE = 'NEW_ANNOUNCEMENT'
export const SET_ANNOUNCEMENT_DIALOG_STATE_VISIBLITY = 'SET_ANNOUNCEMENT_DIALOG_STATE_VISIBLITY'
export const SAVE_DELETED_ANNOUNCEMENT_ID = 'SAVE_DELETED_ANNOUNCEMENT_ID'
export const SET_ANNOUNCEMENT_BANNER_SEEN = 'SET_ANNOUNCEMENT_BANNER_SEEN'
export const SET_ANNOUNCEMENT_FORM_VALID = 'SET_ANNOUNCEMENT_FORM_VALID'

// Insight specific
export const INSIGHT_REPORT_LOADING = 'INSIGHT_REPORT_LOADING'
export const INSIGHT_REPORT_FINISHED_LOADING = 'INSIGHT_REPORT_FINISHED_LOADING'
export const INSIGHT_REPORT_FINISHED_LABEL = 'INSIGHT_REPORT_FINISHED_LABEL'
export const INSIGHT_REPORT_LOADING_LABEL = 'INSIGHT_REPORT_LOADING_LABEL'
export const SET_GENERIC_REPORTS = 'SET_GENERIC_REPORTS'

// Groups specific
export const SET_GROUPS_LIST = 'SET_GROUPS_LIST'

export const SET_STUDENT_COUNT_IN_GROUP = 'SET_STUDENT_COUNT_IN_GROUP'
export const SET_GROUP_DETAIL = 'SET_GROUP_DETAIL'
export const SET_GROUP_SENDING = 'SET_GROUP_SENDING'
export const SET_GROUP_LOADING = 'SET_GROUP_LOADING'
export const SET_GROUP_CREATE_LOADING = 'SET_GROUP_CREATE_LOADING'
export const SET_GROUP_UPDATE_LOADING = 'SET_GROUP_UPDATE_LOADING'
export const SET_SELECTED_GROUP = 'SET_SELECTED_GROUP'
export const ADD_TO_GROUP_SUCCESS = 'ADD_TO_GROUP_SUCCESS'
export const CREATE_NEW_GROUP_SUCCESS = 'CREATE_NEW_GROUP_SUCCESS'
export const REMOVE_GROUP = 'REMOVE_GROUP'
export const REMOVE_GROUP_STORAGE = 'REMOVE_GROUP_STORAGE'
export const RESET_ALL_FILTERS = 'RESET_ALL_FILTERS'
export const RESET_ALL_EXCEPT_TUTEES_FILTERS = 'RESET_ALL_EXCEPT_TUTEES_FILTERS'

// Data Purge specific
export const SET_DATA_PURGE_LOADING = 'SET_DATA_PURGE_LOADING'
export const SET_DATA_PURGE_FEED_LOADING = 'SET_DATA_PURGE_FEED_LOADING'
export const SET_DATA_PURGE_SENDING = 'SET_DATA_PURGE_SENDING'
export const SET_DATA_PURGE_REPORT_LOADING = 'SET_DATA_PURGE_REPORT_LOADING'
export const SET_DATA_PURGE_OUTPUT_LOADING = 'SET_DATA_PURGE_OUTPUT_LOADING'
export const SET_DATA_PURGE_ENROLMENT_STATUS = 'SET_DATA_PURGE_ENROLMENT_STATUS'
export const SET_DATA_PURGE_DURATION = 'SET_DATA_PURGE_DURATION'
export const SET_DATA_PURGE_STUDENTS = 'SET_DATA_PURGE_STUDENTS'
export const SET_SELECTED_DURATION = 'SET_SELECTED_DURATION'
export const SET_SELECTED_ENROLMENT_STATUS = 'SET_SELECTED_ENROLMENT_STATUS'
export const SET_DATA_PURGE_SEARCH = 'SET_DATA_PURGE_SEARCH'
export const SET_DATA_PURGE_SEARCH_DISPLAY = 'SET_DATA_PURGE_SEARCH_DISPLAY'
export const SET_DATA_PURGE_FIRST_DELETE_CONFIRMATION = 'SET_DATA_PURGE_FIRST_DELETE_CONFIRMATION'
export const RESET_DATA_PURGE_STUDENTS = 'RESET_DATA_PURGE_STUDENTS'
export const SET_DATA_PURGE_PAGE_NUMBER = 'SET_DATA_PURGE_PAGE_NUMBER'
export const RESET_PURGE_FILTER_AND_SEARCH = 'RESET_PURGE_FILTER_AND_SEARCH'
export const SET_FEED_IS_RUNNING = 'SET_FEED_IS_RUNNING'
export const SET_HAS_SCHEDULED_TIME = 'SET_HAS_SCHEDULED_TIME'
export const SET_DATA_PURGE_SCHEDULE = 'SET_DATA_PURGE_SCHEDULE'

// Config specific
export const SET_CATEGORY_LOADING = 'SET_CATEGORY_LOADING'
export const SET_REFERRAL_LOADING = 'SET_REFERRAL_LOADING'
export const SET_EMAIL_TEMPLATE_LOADING = 'SET_EMAIL_TEMPLATE_LOADING'
export const SET_ENROLMENT_STATUS_LOADING = 'SET_ENROLMENT_STATUS_LOADING'
export const SET_CATEGORY_SENDING = 'SET_CATEGORY_SENDING'
export const SET_CATEGORY_LIST = 'SET_CATEGORY_LIST'
export const SET_REFERRAL_LIST = 'SET_REFERRAL_LIST'
export const SET_EMAIL_TEMPLATE_LIST = 'SET_EMAIL_TEMPLATE_LIST'
export const SET_EMAIL_TEMPLATE_PLACEHOLDERS = 'SET_EMAIL_TEMPLATE_PLACEHOLDERS'
export const SET_ENROLMENT_STATUS_DATA = 'SET_ENROLMENT_STATUS_DATA'
export const SET_CUSTOM_TEXT_LOADING = 'SET_CUSTOM_TEXT_LOADING'
export const SET_CUSTOM_TEXT_LIST = 'SET_CUSTOM_TEXT_LIST'
export const ADD_CATEGORY_ITEM = 'ADD_CATEGORY_ITEM'
export const UPDATE_CATEGORY_STATUS = 'UPDATE_CATEGORY_STATUS'

// Help specific
export const SET_HELP_LOADING = 'SET_HELP_LOADING'
export const SET_HELP_DATA = 'SET_HELP_DATA'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js